export default __webpack_public_path__ + "static/media/top3-medal-icon.bc5cd693.svg";